import qs from 'qs';
import { deepMerge } from '../deepMerge/deepMerge';
import { isEmpty } from '../isEmpty/isEmpty';
import { isString } from '../isString/isString';
export const QUERY_STRINGIFY_OPTIONS = {
    encode: false,
    encoder: (str, defaultEncoder, charset, type) => {
        if (type === 'value') {
            return defaultEncoder(str, defaultEncoder, charset);
        }
        return str;
    },
    skipNulls: true,
    allowDots: false,
    indices: false,
    arrayFormat: 'brackets',
    addQueryPrefix: true,
};
/**
 * Generate query string with income parameters.
 *
 * Under the hood it uses npm package "qs", [https://www.npmjs.com/package/qs](https://www.npmjs.com/package/qs).
 *
 * @param {Object|string} params Income parameters.
 * @param {GenerateSearchQueryOptions=} options Uses options from "qs", check stringify method [https://github.com/ljharb/qs?tab=readme-ov-file#stringifying](https://github.com/ljharb/qs?tab=readme-ov-file#stringifying).
 * @returns {string}
 *
 * @example
 * // If params object is "{ a: 1 }", returns "?a=1"
 * generateSearchQuery({ a: 1 });
 */
export function generateSearchQuery(params, options = {}) {
    if (isEmpty(params)) {
        return '';
    }
    const stringifyOptions = deepMerge(QUERY_STRINGIFY_OPTIONS, options);
    if (isString(params)) {
        return `${stringifyOptions.addQueryPrefix ? '?' : ''}${params}`;
    }
    return qs.stringify(params, stringifyOptions);
}
